<template>
  <b-container class="py-4 card" v-if="item">
    <b-form @submit.stop.prevent="edit_item">

      <b-form-group label="Keywords:" description="Name of the site">
        <b-form-tags v-model="item.keywords" required></b-form-tags>
      </b-form-group>

      <LoadingButton type="submit" variant='primary' :loading="is_saving">Save</LoadingButton>
    </b-form>

  </b-container>
</template>

<script>
import { db } from '@/main.js'
import ItemMixin from "@/mixins/Item.js"

export default {
  name: 'keywords',
  mixins: [ItemMixin],
  firestore: function () {
    return {
      item: db.collection(this.collection).doc(this.$route.params.site_id)
    }
  },
  validations: {
    item: {}
  },
  data() {
    return {
      item: undefined,
      is_saving: false,
      collection: 'site'
    }
  },
}
</script>

<style scoped>

</style>
